import React, { useState } from 'react';
import "./Login.css";
import { Button } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { auth } from "../firebase";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const history = useHistory("");
    
    const handleSignIn = (e) => {
        e.preventDefault();
        auth.signInWithEmailAndPassword(email, password).then((redirect) => {
            history.push("/home")
        }).catch((error) => {
            if (error.message === "There is no user record corresponding to this identifier. The user may have been deleted.") {
                alert("Please check your email and password again.")
            } else if (error.message === "The password is invalid or the user does not have a password.") {
                alert("Please check your email and password once again.")
            } else {
                alert(error.message)
            }
        })
    }

    return (
        <div className="login">
            <div className="login__header">
                <img src="Images/TiTaniht-logo.png" alt="TiTaniht" />
                <h2>Login to TiTaniht</h2>
            </div>
            <div className="login__inputs">
                <input type="email" placeholder="Enter the Email Address which you have used while creating your TiTaniht's account." value={email} onChange={(e) => setEmail(e.target.value)} />
                <input type="password" placeholder="Enter the password which you have set for your TiTaniht's account" value={password} onChange={(e) => setPassword(e.target.value)} />
                <Button onClick={handleSignIn} type="submit" className="login__loginButton">Login to TiTaniht</Button>
                <p>or</p>
                <Link className="link" to="/register"><Button className="login__registerButton">Create a new Account</Button></Link>
            </div>
        </div>
    )
}

export default Login;